import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  CircularProgress,
  Button,
  Box,
} from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import LoadingAnimation from "../../../Animations/LoadingAnimation";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../Pagination";

const BlogsManagement = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();

  const fetchBlogs = async (page) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_SERVER_BASE_URL}/blog/all?page=${page}`
      );
      const data = await response.json();
      setBlogs(data.blogs);
      setTotalPages(data.totalPages);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs(currentPage);
  }, [currentPage]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleEdit = (slug) => {
    console.log("Edit blog:", slug);
    // Implement navigation to edit blog page
  };

  const handleDelete = (slug) => {
    console.log("Delete blog:", slug);
    // Implement delete functionality
  };

  const handlePostBlog = () => {
    navigate("/admin/blog/new");
  };

  return (
    <Container sx={{ mt: 4, mb: 5 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontFamily: "ClashGrotesk-Medium",
            letterSpacing: 1,
            color: "var(--primary-color)",
          }}
        >
          Manage Blogs
        </Typography>
        <Button
          onClick={handlePostBlog}
          className="main-button-style"
          sx={{
            mt: 3,
            mb: 3,
            padding: "8px 25px",
            backgroundColor: "var(--primary-color)",
            color: "white",
            fontFamily: "ClashGrotesk-Medium",
            letterSpacing: 1,
            textTransform: "uppercase",
            borderRadius: "50px",
            cursor: "pointer",
            transition: "background-color 0.3s ease-in-out",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            "&:focus, &:active": { outline: "none" },
            "&:hover": { color: "white" },
          }}
          disabled={loading}
        >
          <span>Post Blog</span>
          <ArrowForwardOutlinedIcon fontSize="small" />
        </Button>
      </Box>

      {loading ? (
        <LoadingAnimation />
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Title</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Author</TableCell>
                <TableCell>Reads</TableCell>
                <TableCell>Published Date</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {blogs.map((blog) => (
                <TableRow key={blog._id.$oid}>
                  <TableCell>{blog.title}</TableCell>
                  <TableCell>{blog.category}</TableCell>
                  <TableCell>{blog.author}</TableCell>
                  <TableCell>{blog.reads}</TableCell>
                  <TableCell>
                    {new Date(blog.publishedAt).toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      color="primary"
                      onClick={() => handleEdit(blog.slug)}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => handleDelete(blog.slug)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </Container>
  );
};

export default BlogsManagement;
